import React, { useEffect, useRef, useState } from 'react';
import './ContactUs.css';

const ContactUs = () => {
  const formRef = useRef(null);
  const [footerAddress, setFooterAddress] = useState([]);
  const [footerSocial, setFooterSocial] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitState, setSubmitState] = useState({ type: '', message: '' });

  useEffect(() => {
    fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/footer-social`)
      .then((res) => res.json())
      .then((info) => setFooterSocial(info));
  }, []);

  useEffect(() => {
    fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/footer-address`)
      .then((res) => res.json())
      .then((info) => setFooterAddress(info));
  }, [footerAddress]);

  const handleMessage = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setSubmitState({ type: '', message: '' });

    const name = event.target.name.value;
    const email = event.target.email.value;
    const number = event.target.number.value;
    const subject = event.target.subject.value;
    const message = event.target.message.value;
    const messageStatus = event.target.messageStatus.value;

    const addItem = {
      name,
      email,
      number,
      subject,
      message,
      messageStatus,
    };

    const url = `https://ai-automation-audit-01-e0855711738d.herokuapp.com/add-message`;

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify(addItem),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || 'Failed to send message.');
      }

      const emailNotificationFailed =
        result.emailNotificationStatus &&
        result.emailNotificationStatus !== 'sent';

      setSubmitState(
        emailNotificationFailed
          ? {
              type: 'warning',
              message:
                'Your message was saved, but the email notification could not be sent yet. We will still review it shortly.',
            }
          : {
              type: 'success',
              message:
                'Thank you! Your message has been sent successfully. We will get back to you as soon as possible.',
            }
      );

      // Trigger GTM, GA4 and Meta Pixel tracking events for the Lead conversion
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'lead_form_submission',
          formName: 'Contact Us Form'
        });

        if (typeof window.gtag === 'function') {
          window.gtag('event', 'generate_lead', {
            event_category: 'engagement',
            event_label: 'Contact Us Form'
          });
        }

        if (typeof window.fbq === 'function') {
          window.fbq('track', 'Lead');
        }
      } catch (analyticsError) {
        console.error('Analytics tracking failed:', analyticsError);
      }

      formRef.current?.reset();
    } catch (error) {
      console.error('Error:', error);
      setSubmitState({
        type: 'error',
        message:
          error.message ||
          'We could not send your message right now. Please try again.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const [action, setAction] = useState([]);

  useEffect(() => {
    fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/actions`)
      .then((res) => res.json())
      .then((info) => setAction(info));
  }, []);

  return (
    <>
      <div id="contact-sec">
        <div>
          <section className="contact-section pb_150">
            <div className="auto-container">
              <div data-animation-box className="sec-title mb_55 centred">
                <span data-animation-text className="sub-title ">
                  Contact Now
                </span>
                <h2>Get in Touch</h2>
              </div>
              <div className="form-inner">
                <form
                  ref={formRef}
                  onSubmit={handleMessage}
                  method="post"
                  id="contact-form"
                >
                  <div className="row clearfix">
                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                      <input
                        type="text"
                        name="name"
                        placeholder="Your Name"
                        required
                      />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                      <input
                        type="email"
                        name="email"
                        placeholder="Your email"
                        required
                      />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                      <input
                        type="text"
                        name="number"
                        required
                        placeholder="Phone"
                      />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                      <input
                        type="text"
                        name="subject"
                        required
                        placeholder="Subject"
                      />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                      <input
                        name="messageStatus"
                        value="UnRead"
                        hidden
                        readOnly
                        placeholder="Message Status"
                      />
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                      <textarea
                        name="message"
                        placeholder="Type message"
                        defaultValue=""
                      />
                    </div>

                    {submitState.message ? (
                      <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                        <div
                          className={`contact-form-alert ${submitState.type}`}
                          role="status"
                        >
                          {submitState.message}
                        </div>
                      </div>
                    ) : null}

                    <div className="col-lg-12 col-md-12 col-sm-12 form-group message-btn centred">
                      <button
                        className="theme-btn btn-one"
                        type="submit"
                        name="submit-form"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? 'Sending...' : 'Message Now'}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
